import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {SharedService} from "../../services/SharedService.service";
import {MessageService} from "primeng/components/common/messageservice";
import {ConfirmationService} from "primeng/api";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {TranslateService} from "@ngx-translate/core";
import {Router} from "@angular/router";
import {Message} from "primeng/components/common/api";
import {AppPdfComponent} from "../../components/app-pdf";

@Component({
  selector: 'app-dashboard',
  templateUrl: './full-layout.component.html',
  providers: [SharedService, MessageService]
})
export class FullLayoutComponent implements OnChanges {
  title = '';
  msgs: Message[] = [];
  routeButtons: any[];
  public userRoles: any[] = [];
  public icon: string = "star-o";
  public color: string = "#415A63";
  @Input() refShow;
  @Input() filedis;

  itemShow: any;
  modelName = '';
  itemService: any;
  fav: any;

  constructor(private sharedService: SharedService,
              private router: Router,
              private confirmationService: ConfirmationService,
              public translate: TranslateService,
              private sharedservice: SharedService,
              private modalService: NgbModal,
              private messageService: MessageService) {

    const userdata = JSON.parse(localStorage.getItem('currentUser'));
    if (userdata) {
      this.userRoles = userdata.roles.description;

    }


  }

  updateShow() {
    this.itemService = this.sharedService.getItemService();
    this.itemShow = this.sharedService.getItemShow();
    this.modelName = this.sharedService.getModelName();
  }

  ngOnChanges(changes: SimpleChanges) {


  }

  ngOnInit(): void {

    const currentScr = JSON.parse(localStorage.getItem('current_screen'));
    let name = '';
    let code = '';
    if(currentScr){
      name = currentScr.link;
      code = currentScr.code;
    }

    this.sharedService.getAllFav(code).subscribe(
      fav => {
        this.fav = fav;
        let value: any;
        let active: any;
        for (let item of fav) {
          value = item.label;
          active = item.value;

        }

        if (value == name && active == 1) {
          this.icon = "star";
          this.color = "#FFBA35";
        } else {
          this.icon = "star-o";
          this.color = "#415A63";
        }

      }
    );
    this.router.events.subscribe((res) => {

      this.title = this.sharedService.getTitle();
      this.routeButtons = this.sharedService.getButtons();
      this.itemService = this.sharedService.getItemService();
      this.itemShow = this.sharedService.getItemShow();
      this.modelName = this.sharedService.getModelName();
      const userdata = JSON.parse(localStorage.getItem('currentUser'));
      if (userdata) {
        this.userRoles = userdata.roles.description;

      }

    });

    this.title = this.sharedService.getTitle();
    this.routeButtons = this.sharedService.getButtons();
    this.itemService = this.sharedService.getItemService();
    this.itemShow = this.sharedService.getItemShow();
    this.modelName = this.sharedService.getModelName();

    const userdata = JSON.parse(localStorage.getItem('currentUser'));
    if (userdata) {
      this.userRoles = userdata.roles.description;

    }
  }

  getScreenName(): string {
    let urltxt = this.router.url.replace(/^\//, '');
    let urlparts = urltxt.split('/');
    return urlparts[0];
  }


  permissionAllow(button:string):boolean {
    const screen = this.getScreenName();
    let role:string = '';
    if (button === 'undoButton' || button === 'saveButton' || button === 'saveBtmButton' ||button === 'undoBtmButton' ) return true;
    switch(button) {
      case 'newButton': {
        role = 'create';
        break;
      }
      case 'recordButton': {
        role = 'rowinfo';
        break;
      }
      case 'editButton': {
        role = 'update';
        break;
      }
      case 'deleteButton': {
        role = 'delete';
        break;
      }
      case 'searchButton': {
        role = 'search';
        break;
      }
      case 'searchBtmButton': {
        role = 'search';
        break;
      }
      case 'excelButton': {
        role = 'excel';
        break;
      }
      case 'printButton': {
        role = 'print';
        break;
      }
      case 'historyButton': {
        role = 'history';
        break;
      }
      case 'restoreButton': {
        role = 'restore';
        break;
      }
      case 'attachmentsButton': {
        role = 'attachments';
        break;
      } case 'recordData': {
      role = 'record';
      break;
    } case 'undoEditing': {
      role = 'undo';
      break;
    } case 'itemsRecovery': {
      role = 'recovery';
      break;
    }

      default: {
        role = '';
        break;
      }
    }
    let Osystem = 'setting';
    if(localStorage.getItem('OpenSystem')) {
      Osystem = localStorage.getItem('OpenSystem');
    }
    if(this.userRoles.indexOf(Osystem+'.'+screen+'.'+role) >= 0) {
      return true;
    }
    return false;
  }

  displaypdf(){
    let filename= this.sharedservice.getModelName();
    this.sharedService.getfileshow("76").subscribe(
      filedis => {
        this.filedis = filedis;
        modalRef.componentInstance.filedis = filedis;
        console.log(filedis);

      },
      err => {
        console.log(err);
      }
    );
    const modalRef = this.modalService.open(AppPdfComponent);
    modalRef.componentInstance.refShow = this.refShow;
    modalRef.componentInstance.filedis = this.filedis;
    modalRef.componentInstance.screenName = this.modelName;
  }
}



// WEBPACK FOOTER //
// ./src/app/containers/full-layout/full-layout.component.ts